import { createReducer, on } from '@ngrx/store';

import { DashboardActions } from '../actions';
import { DashboardActionsUnion } from '@app/features/dashboard/state/actions/dashboard.actions';

import { PolicyDetails } from '@app/features/dashboard/models/policy-details';

import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';


export interface DashboardState {
  policyChangeType: 'Permanent' | 'Temporary' | string;
  alterOptions: KeyValueDict<boolean>;
  policyChangeDate: Date;
  policyChangeEndDate?: Date;
  policyDetails: PolicyDetails;
  hasMovedAlready: boolean;
  promoCode?: string;
  renewal?: string;
  error: any;
}

export const initialState: DashboardState = {
  policyChangeType: '',
  alterOptions: {
    yourCar: false,
    yourMileage: false,
    yourRegistration: false,
    yourAddresses: false,
    yourDetails: false,
    yourDrivers: false,
    yourConvictions: false,
    addOns: false,
    yourVehicleUsage: false,
    whereIparkMyCar: false,
    renewalPreference: false
  },
  policyChangeDate: null,
  policyChangeEndDate: null,
  policyDetails: null,
  hasMovedAlready: null,
  promoCode: null,
  renewal: null,
  error: null
};

const dashboardReducer = createReducer(
  initialState,
  on(DashboardActions.loadSuccess, (state, {policyDetails}) => ({...state, policyDetails})),
  on(DashboardActions.loadFail, (state, {error}) => ({...state, policyDetails: null, error})),
  on(DashboardActions.changePolicy, (state, {alterOptions}) => ({...state, alterOptions})),
  on(DashboardActions.changePolicyDate, (state, {policyChangeDate}) => ({...state, policyChangeDate})),
  on(DashboardActions.changePolicyType, (state, {policyChangeType}) => ({
    ...state,
    policyChangeType,
    alterOptions: policyChangeType === 'Permanent' ?
      {
        yourCar: false,
        yourMileage: false,
        yourRegistration: false,
        yourDetails: false,
        yourAddresses: false,
        yourDrivers: false,
        yourConvictions: false,
        addOns: false,
        yourVehicleUsage: false,
        whereIparkMyCar: false,
        renewalPreference: false
      }  :
      {temporaryCar: false, temporaryDriver: false, yourTemporaryEuropeanCover: false},
    policyChangeDate: null,
    policyChangeEndDate: null
  })),
  on(DashboardActions.changePolicyEndDate, (state, {policyChangeEndDate}) => ({...state, policyChangeEndDate})),
  on(DashboardActions.changeMovedAlready, (state, {hasMovedAlready}) => ({...state, hasMovedAlready})),
  on(DashboardActions.changePromoCode, (state, {promoCode}) => ({...state, promoCode})),
  on(DashboardActions.changeRenewal, (state, {renewal}) => ({...state, renewal})),
);

export function reducer(state: DashboardState | undefined, action: DashboardActionsUnion) {
  return dashboardReducer(state, action);
}
